<template>
  <main class="w-full flex-grow p-6">
    <button
      @click="showModalFaciliti"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Facility
    </button>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Description</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Image</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Options</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in rows"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.faciliti_name }}
              </span>
            </td>
            <td class="px-16 py-2 text-center">
              <!-- <span>
                {{ sos.faciliti_description }}
              </span> -->
              <span class="ml-5" v-html="sos.faciliti_description"></span>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  class="w-10 h-10"
                  :src="sos.faciliti_image"
                  alt="23paskal"
                />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button class="" type="button" @click="showModalUpdate(sos)">
                  <fas icon="pencil-alt" class="text-app-default text-xl" />
                </button>
                <button
                  class=""
                  type="button"
                  @click="showModalUpdateImage(sos.id)"
                >
                  <fas icon="file-signature" class="text-green-500 text-xl" />
                </button>
                <button
                  class=""
                  type="button"
                  @click="showModalDestroy(sos.id)"
                >
                  <fas icon="trash-alt" class="text-red-600 text-xl" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- modal create -->
    <div
      v-if="modalSosmed"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 700px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">{{ title }}</div>
            <div class="">
              <button
                @click.self="closeModalFaciliti"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="create.faciliti_name"
                  @keyup="facilitiNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.faciliti_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.faciliti_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="create.faciliti_description"
                  @keyup="facilitiDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.faciliti_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.faciliti_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="create.faciliti_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="facilitiDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    create?.faciliti_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ create?.faciliti_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.faciliti_description_msg }}
                </div>
              </div>
            </div>
            <label class="font-semibold text-black opacity-80"
              >Image (150 px X 150 px)</label
            >
            <div class="w-52">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                :class="[
                  errors.faciliti_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewFileFaciliti"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileFaciliti"
                  id="faciliti_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="create.previewFaciliti"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeFleFaciliti()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="create.previewFaciliti"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="create.previewFaciliti === null"
                    v-cloak
                    @click="chooseFacilitiFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.faciliti_image_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalFaciliti"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="saveFaciliti"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalFaciliti"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update content -->
    <div
      v-if="modalUpdate"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 700px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Update Facility</div>
            <div class="">
              <button
                @click.self="closeModalUpdate"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="update.faciliti_name"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                  placeholder="Name"
                />
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="update.faciliti_description"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Description"
                ></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                >
                  <CKEditor
                    v-model="update.faciliti_description"
                    :disabled="false"
                    :toolbar="toolbar"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.faciliti_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.faciliti_description?.length }} used out of 2000
                  characters
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalUpdate"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateFaciliti"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalUpdate"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update image -->
    <div
      v-if="modalUpdateImage"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Facility Image (150 px X 150 px)
            </div>
            <div class="">
              <button
                @click.self="closeModalUpdateImage"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                @drop="previewFileFaciliti"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileFaciliti"
                  id="faciliti_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="create.previewFaciliti"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeFleFaciliti()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="create.previewFaciliti"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="create.previewFaciliti === null"
                    v-cloak
                    @click="chooseFacilitiFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalUpdateImage"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!create.previewFaciliti"
                @click.self="updateFacilitiImage"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  !create.previewFaciliti ? 'bg-gray-500' : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalUpdateImage"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Warning !</div>
            <div class="">
              <button
                @click.self="closeModalDestroy"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            Are You Sure To Continue Delete This Faciliti
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <button
                @click="deleteFaciliti"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Table",
  components: { Warning, CKEditor, SuccessNotif },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      modalDestroy: false,
      preview: null,
      image: null,
      preview_list: [],
      image_list: [],
      modalSosmed: false,
      modalUpdate: false,
      modalUpdateImage: false,
      title: "",
      actionType: null,
      errors: {
        faciliti_image: false,
        faciliti_image_msg: "",
        faciliti_name: false,
        faciliti_name_msg: "",
        faciliti_description: false,
        faciliti_description_msg: "",
      },
      create: {
        faciliti_name: "",
        faciliti_description: "",
        previewFaciliti: null,
        imageFaciliti: null,
      },
      update: {
        faciliti_name: "",
        faciliti_description: "",
      },
      rows: [],
      id: null,
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    facilitiNameChange: function(e) {
      this.create.faciliti_name = e.target.value;
      this.errors.faciliti_name = false;
      this.errors.faciliti_name_msg = "";
    },
    facilitiDescriptionChange: function() {
      // this.create.faciliti_description = e.target.value;
      this.errors.faciliti_description = false;
      this.errors.faciliti_description_msg = "";
    },
    chooseFacilitiFile: function() {
      document.getElementById("faciliti_file").click();
    },
    previewFileFaciliti: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.create.previewFaciliti = e.target.result;
        };
        this.create.imageFaciliti = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.faciliti_image = false;
      this.errors.faciliti_image_msg = "";
    },
    removeFleFaciliti: function() {
      this.create.previewFaciliti = null;
      this.create.imageFaciliti = null;
    },
    showModalDestroy: function(id) {
      this.id = id;
      this.modalDestroy = true;
    },
    closeModalDestroy: function() {
      this.id = null;
      this.modalDestroy = false;
    },
    showModalFaciliti: function() {
      this.title = "Create New Facility";
      this.create = {
        faciliti_name: "",
        faciliti_description: "",
        previewFaciliti: null,
        imageFaciliti: null,
      };
      this.modalSosmed = true;
    },
    closeModalFaciliti: function() {
      this.modalSosmed = false;
    },
    showModalUpdate: function(val) {
      this.id = val.id;
      this.update.faciliti_name = val.faciliti_name;
      this.update.faciliti_description = val.faciliti_description;
      this.modalUpdate = true;
    },
    closeModalUpdate: function() {
      this.id = null;
      this.modalUpdate = false;
    },
    showModalUpdateImage: function(id) {
      this.id = id;
      this.create.previewFaciliti = null;
      this.create.imageFaciliti = null;
      this.modalUpdateImage = true;
    },
    closeModalUpdateImage: function() {
      this.id = null;
      this.previewFaciliti = null;
      this.imageFaciliti = null;
      this.modalUpdateImage = false;
    },
    findFacilities: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/facilities`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.rows = respon.data.facility;
        this.totalRecordCount = respon.data.facility.length;
      } catch (err) {
        this._error("internal server error");
      }
    },
    saveFaciliti: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("faciliti_image", this.create.imageFaciliti);
      formdata.append("faciliti_name", this.create.faciliti_name);
      formdata.append("faciliti_description", this.create.faciliti_description);
      try {
        let res = await fetch(`${API}v1/admin/cms/facilities/store`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "faciliti_image") {
                this.errors.faciliti_image = true;
                this.errors.faciliti_image_msg = item.message;
              }
              if (item.key === "faciliti_name") {
                this.errors.faciliti_name = true;
                this.errors.faciliti_name_msg = item.message;
              }
              if (item.key === "faciliti_description") {
                this.errors.faciliti_description = true;
                this.errors.faciliti_description_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalSosmed = false;
        this.saveButton = "save";
        this.findFacilities();
        this._success("Data has been saved.");
      } catch (err) {
        this._error("internal server error");
        this.saveButton = "save";
      }
    },
    updateFacilitiImage: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("faciliti_image", this.create.imageFaciliti);
      formdata.append("id", this.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/facilities/update-image`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.saveButton = "Save";
        this.modalUpdateImage = false;
        this.findFacilities();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateFaciliti: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/facilities/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
            faciliti_name: this.update.faciliti_name,
            faciliti_description: this.update.faciliti_description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.modalUpdate = false;
        this.findFacilities();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this._error("internal server error");
        this.saveButton = "Save";
      }
    },
    deleteFaciliti: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/facilities/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.findFacilities();
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findFacilities();
  },
};
</script>
